import {DatePipe} from "@angular/common";
import {inject, Pipe, PipeTransform} from "@angular/core";
import {SimTimeService} from "src/app/core/services/sim-services/sim-time.service";

/**
 * DatePipe wrapper, which transforms a time range (Date obj or ISO string) into a human-readable label.
 * Displays either a range, or just the start time if endTime === startTime
 */
@Pipe({
	name: "timeRangeLabel",
	pure: false,
})
export class TimeRangeLabelPipe implements PipeTransform {
	readonly #datePipe = inject(DatePipe);
	readonly #timeFormat = inject(SimTimeService).timeFormat;

	transform(startTime: string | Date, endTime: string | Date, inputFormat?: string | undefined): string | null {
		const start = new Date(startTime);
		const end = new Date(endTime);
		const format = inputFormat ?? this.#timeFormat();

		const isSameTime = end.getTime() === start.getTime();
		const formatIncludesTime = /[Hhms]/.test(format);
		const isSameDay =
			start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth() && start.getDate() === end.getDate();

		if (isSameTime || (!formatIncludesTime && isSameDay)) {
			return this.#datePipe.transform(start, format);
		} else {
			return `${this.#datePipe.transform(start, format)} - ${this.#datePipe.transform(end, format)}`;
		}
	}
}
